import { useEffect } from 'react';
import { useAppConfig } from '../AppConfigContext';
const Redirect = ({
  to
}) => {
  const {
    replace
  } = useAppConfig();
  useEffect(() => {
    replace(to);
  }, [replace, to]);
  return null;
};
export default Redirect;